import React from "react";
import styled from "styled-components";
import { Loader } from "@vds/loaders";

export const ComponentLoaderWrapper = styled.div`
  left: 0;
  right: 0;
  z-index: 99999;
  position: center;
  display: block;
`;


export default function ComponentLoader() {

    return (
        <ComponentLoaderWrapper>
            <Loader active />
        </ComponentLoaderWrapper>
    )
}